export const requireDOMReady = (cb: () => void) => {
  //If document is already ready we execude the callback immediately
  if (document.readyState === "complete") return cb();
  //Otherwise we add an onload event on the window
  window.addEventListener("load", cb);
  //return unlisten function
  return () => window.removeEventListener("load", cb);
};
